SNI.Application.addModule('show-promo', context => {

  return {
    behaviors: ['lazy-load']
  };

});
